module.exports = __webpack_public_path__ + "static/media/logo.c0d6d8c0.png";